import React, { useContext, useState, Suspense } from 'react';
import { number } from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/grid';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Image } from '@thd-olt-component-react/core-ui';
import classNames from 'classnames';
import {
  DrawerItem,
  DrawerNav
} from '@thd-olt-component-react/drawer';
import { constants } from '../CollectionHelpers';

const Drawer = React.lazy(() => import(/* webpackChunkName: "drawer" */ '@thd-olt-component-react/drawer')
  .then((module) => ({ default: module.Drawer })));

export const FabricOverview = ({ maxSwatchImagesPerRow }) => {
  const { channel } = useContext(ExperienceContext);
  const [opened, setOpened] = useState(false);
  const isMobile = channel === 'mobile';

  const openDrawer = (event) => {
    event.preventDefault();
    setOpened(true);
  };

  const renderFabricSpec = (type) => {
    if (type === 'CushionGuard') {
      return (
        <ul className="list list--bottomSpace">
          <li className="list__item">Exclusive to The Home Depot</li>
          <li className="list__item">Durable acrylic fabric</li>
          <li className="list__item">
            Resists water, fading and stains
          </li>
          <li className="list__item">
            Cushion slipcovers come with a 3-year limited warranty
          </li>
        </ul>
      );
    }
    if (type === 'Sunbrella') {
      return (
        <ul className="list list--bottomSpace">
          <li className="list__item">
            Premium, durable performance acrylic fabric
          </li>
          <li className="list__item">Resists water and fading</li>
          <li className="list__item">Machine washable</li>
          <li className="list__item">
            Comes with a 5-year limited warranty
          </li>
          <li className="list__item">
            Umbrellas provide 98% UV protection
          </li>
        </ul>
      );
    }
    return null;
  };
  const getAvailableFabric = (type) => {
    let swatchRows = [];
    const swatchList = constants.FABRIC_SWATCHES[type];
    if (swatchList && swatchList.length > maxSwatchImagesPerRow) {
      const halfOfSwatchListIndex = Math.ceil(swatchList.length / 2);
      swatchRows.push(swatchList.slice(0, halfOfSwatchListIndex));
      swatchRows.push(swatchList.slice(halfOfSwatchListIndex));
    } else {
      swatchRows.push(swatchList || []);
    }
    return (
      <Row className={classNames('swatch_wrapper', { 'swatch_wrapper--no-padding': isMobile })}>
        {renderFabricSpec(type)}
      </Row>
    );
  };
  return (
    <>
      <button
        type="button"
        className="fabric-overlay fabric-overlay-btn u__bold"
        onClick={openDrawer}
      >
        View Fabric & Color Overview
        <Image
          className="carrot"
          src="https://assets.thdstatic.com/images/v1/caret-orange.svg"
          alt=""
          height={13}
          width={10}
        />
      </button>
      {opened && (
        <Suspense fallback={(<div />)}>
          <Drawer
            open={opened}
            onClose={() => setOpened(false)}
            initialItem="drawer-title"
            isMobile={isMobile}
            maxSize={isMobile ? 100 : 400}
          >
            <DrawerItem name="drawer-title">
              <DrawerNav>
                <span style={{ fontWeight: 'bold' }}>Fabric & Color Overview</span>
              </DrawerNav>
              <Row className="fabric-overlay-content grouped-view">
                <Col xs="12" className="fabric__wrapper">
                  <h4 className="fabric_title cushion">
                    <Image
                      src="https://assets.thdstatic.com/images/v1/CushionGuard.png"
                      alt="CushionGuard"
                      height={34}
                      width={302}
                    />
                  </h4>
                  {getAvailableFabric('CushionGuard')}
                  <ul className="fabric">
                    <li className="fabric__specifications fabric__specifications--3year-warranty" />
                    <li className="fabric__specifications fabric__specifications--stain-resistant" />
                    <li className="fabric__specifications fabric__specifications--fade-resistant" />
                    <li className="fabric__specifications fabric__specifications--spill-resistant" />
                  </ul>
                </Col>
                <Col xs="12" className="fabric__wrapper">
                  <h4 className="fabric_title">
                    <Image
                      src="https://assets.thdstatic.com/images/v1/Sunbrella.png"
                      alt="Sunbrella"
                      height={54}
                      width={200}
                    />
                  </h4>
                  {getAvailableFabric('Sunbrella')}
                  <ul className="fabric">
                    <li className="fabric__specifications fabric__specifications--5year-warranty" />
                    <li className="fabric__specifications fabric__specifications--stain-resistant" />
                    <li className="fabric__specifications fabric__specifications--fade-resistant" />
                    <li className="fabric__specifications fabric__specifications--machine-washable" />
                  </ul>
                </Col>
              </Row>
            </DrawerItem>
          </Drawer>
        </Suspense>
      )}
    </>
  );
};

FabricOverview.displayName = 'FabricOverview';

FabricOverview.propTypes = {
  maxSwatchImagesPerRow: number
};

FabricOverview.defaultProps = {
  maxSwatchImagesPerRow: 8
};